import { typedApi } from "@/api/typed-client";
import { useQuery } from "@tanstack/react-query";

export type Family = "tabular" | "anomaly" | "forecast";

export interface TrainingMode {
  name: string;
  description?: string;
  preset?: string;
  available: boolean;
  reason_if_unavailable?: string;
}

export interface TrainingOptions {
  family: Family;
  modes: TrainingMode[];
  eval_metrics: string[];
  advanced_keys: string[];
  notes?: string;
  cluster?: { total_workers: number; gpu_workers: number; note: string };
}

export function useTrainingOptions(family: Family | null) {
  return useQuery({
    enabled: !!family,
    queryKey: ["training_options", family],
    queryFn: async () => {
      const { data, error } = await typedApi.GET("/v1/training_options/{family}", {
        // biome-ignore lint/style/noNonNullAssertion: guarded by enabled: !!family
        params: { path: { family: family! } },
      });
      if (error) throw new Error("Failed to load training options");
      // Justified: training_options response is {[key:string]:unknown} in openapi schema
      return data as unknown as TrainingOptions;
    },
    staleTime: 10_000,
  });
}
